// extracted by mini-css-extract-plugin
export default {"icon":"icons_icon__Js3RT"};